import { all, fork } from 'redux-saga/effects';
import watchUser from './UserSaga';
import watchCoupon from './CouponSaga';
import watchRestaurant from './AppUserSaga';

export default function* () {
  yield all([fork(watchUser), fork(watchCoupon)]);
  yield all([fork(watchUser), fork(watchRestaurant)]);
}
